import useNextRouteMatch from './useRouteMatch';

export default useNextRouteMatch;
